export const menuSemanticClassNames = {
  root: 'menu',
  item: 'menu__item',
  itemLabel: 'menu__item-label',
  scrollButton: 'menu__scroll-button',
  scrollButtonIcon: 'menu__scroll-button-icon',
  itemIcon: 'menu__item-icon',
} as const;

export const shmSemanticClassNames = {
  root: 'horizontal-menu',
  menuItemWrapper: 'horizontal-menu__item',
  menuItemLabel: 'horizontal-menu__item-label',
} as const;

export const dropdownSemanticClassNames = {
  root: 'dropdown-menu',
  dropdownItem: 'dropdown-menu__item',
  dropdownItemLabel: 'dropdown-menu__item-label',
  dropdownSubItem: 'dropdown-menu__subitem',
  dropdownSubItemLabel: 'dropdown-menu__subitem-label',
} as const;
